import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const initial = {
  entered:false, introPhase:'pearl', mode:'overview', activeEssay:null, activeTheme:null,
  freeExplore:false, progress:0, ropeProjection:[], routeProjections:{}, guided:false,
  documentaryBeat:0, cameraDirective:null, weatherPhase:'dawn-clear', timeOfDay:.18,
  readEssayIds:[], indexOpen:false, photoMode:false, fieldMode:'fly', returnToRope:false,
  routeMagnetism:.12, returnToRopeRequest:0,
}

export const useExpedition = create(persist((set,get) => ({
  ...initial,
  enter:() => set({entered:true,introPhase:'departing',mode:'opening',freeExplore:false,cameraDirective:{type:'office',id:'opening-office',position:[6,3.5,-17],target:[2,-3.4,-8.5],fov:32,speed:1.1}}),
  finishIntro:() => set({introPhase:'complete',mode:'overview',freeExplore:true,cameraDirective:null}),
  exit:() => set({...initial,readEssayIds:get().readEssayIds,routeProjections:get().routeProjections}),
  setMode:mode => set({mode}),
  selectEssay:activeEssay => set(state=>({activeEssay,progress:activeEssay?.index??state.progress,mode:activeEssay?'essay':'journey',readEssayIds:activeEssay?[...new Set([...state.readEssayIds,activeEssay.id])]:state.readEssayIds})),
  selectTheme:activeTheme => set({activeTheme,freeExplore:!activeTheme,activeEssay:null,guided:false,returnToRope:false}),
  setProgress:progress => set({progress}),
  setRopeProjection:ropeProjection => set({ropeProjection}),
  registerRouteProjection:(theme,projection) => set(state=>({routeProjections:{...state.routeProjections,[theme]:projection}})),
  setGuided:guided => set({guided}),
  setDocumentary:(guided,documentaryBeat=0) => set({guided,documentaryBeat,freeExplore:!guided}),
  setDocumentaryBeat:documentaryBeat => set({documentaryBeat}),
  setCameraDirective:cameraDirective => set({cameraDirective}),
  setConditions:(weatherPhase,timeOfDay) => set({weatherPhase,...(timeOfDay==null?{}:{timeOfDay})}),
  toggleFreeExplore:() => set(state=>({freeExplore:!state.freeExplore,activeEssay:null,guided:false,cameraDirective:null,returnToRope:false})),
  requestReturnToRope:() => set(state=>({returnToRope:true,freeExplore:false,returnToRopeRequest:state.returnToRopeRequest+1})),
  completeCameraTransition:() => set({returnToRope:false}),
  clearReturnToRope:() => set({returnToRope:false}),
  toggleIndex:() => set(state=>({indexOpen:!state.indexOpen})),
  closeIndex:() => set({indexOpen:false}),
  togglePhotoMode:() => set(state=>({photoMode:!state.photoMode,indexOpen:false})),
  setFieldMode:fieldMode => set({fieldMode}),
  reset:() => set({...initial,entered:true,introPhase:'complete',freeExplore:true,readEssayIds:get().readEssayIds,routeProjections:get().routeProjections}),
  clearFieldNotes:() => set({readEssayIds:[]}),
}),{
  name:'bv-perspectives-v6',
  partialize:state=>({readEssayIds:state.readEssayIds,fieldMode:state.fieldMode}),
}))
